// @flow strict
/* eslint-disable css-modules/no-unused-class */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */

import * as React from 'react';
import cx from 'classnames';
import { Lozenge, LozengeGroup } from '@ansarada/ace-react';
import styles from '../styles.scss';

export const dataPlans = ['250 MB', '1 GB', '2 GB', '4 GB', 'More than 4 GB'];
export const subscriptionPlans = ['Monthly', '3 months', '6 months', '12 months'];

export const DataNDuration = ({
  values,
  setFieldValue,
  setFieldTouchedByName,
  validateForm,
  setShowingDialog,
  footerRef,
}: any) => {
  React.useEffect(() => {
    validateForm();
  }, []);
  return (
    <div>
      <div className={cx([styles.section, styles.sectionBig])}>
        <h2 className={styles.question}>What data plan best matches your needs?</h2>
        <p className={styles.label}>Small deals typically use 250 MB or less</p>
        <LozengeGroup>
          {dataPlans.map(item => (
            // $FlowFixMe
            <span
              className={styles.lozengeBtn}
              role="button"
              onClick={() => {
                if (item === 'More than 4 GB') {
                  setShowingDialog(true);
                  setFieldValue('DataPlan', undefined);
                } else {
                  setFieldTouchedByName('DataPlan')();
                  setFieldValue('DataPlan', item);
                  if (values.SubscriptionPlan && footerRef.current) {
                    footerRef.current.scrollIntoViewIfNeeded();
                  }
                }
              }}
            >
              <Lozenge
                text={item}
                backgroundColor={item === values.DataPlan ? '#c9fb00' : undefined}
                textColor="#07070c"
                // key={`DataPlan-${item}`}
                // pressed={item === values.DataPlan}
              />
            </span>
          ))}
        </LozengeGroup>
      </div>
      <div className={cx([styles.section, styles.sectionBig])}>
        <h2 className={styles.question}>What duration best matches your needs?</h2>
        {/* <p className={styles.label}>If you are unsure choose monthly.</p> */}
        <LozengeGroup>
          {subscriptionPlans.map(item => (
            // $FlowFixMe
            <span
              className={styles.lozengeBtn}
              role="button"
              onClick={() => {
                setFieldTouchedByName('SubscriptionPlan')();
                setFieldValue('SubscriptionPlan', item);
                if (footerRef.current) {
                  footerRef.current.scrollIntoViewIfNeeded();
                }
              }}
              // pressed={item === values.SubscriptionPlan}
            >
              <Lozenge
                text={item}
                backgroundColor={item === values.SubscriptionPlan ? '#c9fb00' : undefined}
                textColor="#07070c"
              />
            </span>
          ))}
        </LozengeGroup>
      </div>
    </div>
  );
};
